import { render } from "./Privilege.vue?vue&type=template&id=bc6a550c"
import script from "./Privilege.vue?vue&type=script&lang=js"
export * from "./Privilege.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__